module.exports = __webpack_public_path__ + "media/images/flags/1x1/srb-39715e57c23e137430bb339819bd373d.svg";